// TODO: change this into a for loop for variable pack size
const foamTiles = {
  5: {
    tile_1: {
      width: 150,
      height: 150,
      left: 0,
      top: 0,
    },
    tile_2: {
      width: 150,
      height: 150,
      left: 170,
      top: 0,
    },
    tile_3: {
      width: 150,
      height: 150,
      left: 340,
      top: 0,
    },
    tile_4: {
      width: 150,
      height: 150,
      left: 75,
      top: 170,
    },
    tile_5: {
      width: 150,
      height: 150,
      left: 245,
      top: 170,
    }
  },
  10: {
    tile_1: {
      width: 125,
      height: 125,
      left: 0,
      top: 0,
    },
    tile_2: {
      width: 125,
      height: 125,
      left: 135,
      top: 0,
    },
    tile_3: {
      width: 125,
      height: 125,
      left: 270,
      top: 0,
    },
    tile_4: {
      width: 125,
      height: 125,
      left: 405,
      top: 0,
    },
    tile_5: {
      width: 125,
      height: 125,
      left: 0,
      top: 135,
    },
    tile_6: {
      width: 125,
      height: 125,
      left: 135,
      top: 135,
    },
    tile_7: {
      width: 125,
      height: 125,
      left: 270,
      top: 135,
    },
    tile_8: {
      width: 125,
      height: 125,
      left: 405,
      top: 135,
    },
    tile_9: {
      width: 125,
      height: 125,
      left: 135,
      top: 270,
    },
    tile_10: {
      width: 125,
      height: 125,
      left: 270,
      top: 270,
    }
  },
  15: {
    tile_1: {
      width: 100,
      height: 100,
      left: 0,
      top: 0,
    },
    tile_2: {
      width: 100,
      height: 100,
      left: 110,
      top: 0,
    },
    tile_3: {
      width: 100,
      height: 100,
      left: 220,
      top: 0,
    },
    tile_4: {
      width: 100,
      height: 100,
      left: 330,
      top: 0,
    },
    tile_5: {
      width: 100,
      height: 100,
      left: 440,
      top: 0,
    },
    tile_6: {
      width: 100,
      height: 100,
      left: 0,
      top: 110,
    },
    tile_7: {
      width: 100,
      height: 100,
      left: 110,
      top: 110,
    },
    tile_8: {
      width: 100,
      height: 100,
      left: 220,
      top: 110,
    },
    tile_9: {
      width: 100,
      height: 100,
      left: 330,
      top: 110,
    },
    tile_10: {
      width: 100,
      height: 100,
      left: 440,
      top: 110,
    },
    tile_11: {
      width: 100,
      height: 100,
      left: 0,
      top: 220,
    },
    tile_12: {
      width: 100,
      height: 100,
      left: 110,
      top: 220,
    },
    tile_13: {
      width: 100,
      height: 100,
      left: 220,
      top: 220,
    },
    tile_14: {
      width: 100,
      height: 100,
      left: 330,
      top: 220,
    },
    tile_15: {
      width: 100,
      height: 100,
      left: 440,
      top: 220,
    }
  },
  20: {
    tile_1: {
      width: 100,
      height: 100,
      left: 0,
      top: 0,
    },
    tile_2: {
      width: 100,
      height: 100,
      left: 110,
      top: 0,
    },
    tile_3: {
      width: 100,
      height: 100,
      left: 220,
      top: 0,
    },
    tile_4: {
      width: 100,
      height: 100,
      left: 330,
      top: 0,
    },
    tile_5: {
      width: 100,
      height: 100,
      left: 440,
      top: 0,
    },
    tile_6: {
      width: 100,
      height: 100,
      left: 0,
      top: 110,
    },
    tile_7: {
      width: 100,
      height: 100,
      left: 110,
      top: 110,
    },
    tile_8: {
      width: 100,
      height: 100,
      left: 220,
      top: 110,
    },
    tile_9: {
      width: 100,
      height: 100,
      left: 330,
      top: 110,
    },
    tile_10: {
      width: 100,
      height: 100,
      left: 440,
      top: 110,
    },
    tile_11: {
      width: 100,
      height: 100,
      left: 0,
      top: 220,
    },
    tile_12: {
      width: 100,
      height: 100,
      left: 110,
      top: 220,
    },
    tile_13: {
      width: 100,
      height: 100,
      left: 220,
      top: 220,
    },
    tile_14: {
      width: 100,
      height: 100,
      left: 330,
      top: 220,
    },
    tile_15: {
      width: 100,
      height: 100,
      left: 440,
      top: 220,
    },
    tile_16: {
      width: 100,
      height: 100,
      left: 0,
      top: 330,
    },
    tile_17: {
      width: 100,
      height: 100,
      left: 110,
      top: 330,
    },
    tile_18: {
      width: 100,
      height: 100,
      left: 220,
      top: 330,
    },
    tile_19: {
      width: 100,
      height: 100,
      left: 330,
      top: 330,
    },
    tile_20: {
      width: 100,
      height: 100,
      left: 440,
      top: 330,
    }
  }
};
export default foamTiles;
